"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Executor = void 0;
var messageListeners_1 = require("./messageListeners");
var results_1 = require("./results");
var context_1 = require("./context");
var util_1 = require("../util/util");
var Executor = /** @class */ (function () {
    function Executor(library, codeService, parameters, messageListener) {
        if (messageListener === void 0) { messageListener = new messageListeners_1.NullMessageListener(); }
        this.library = library;
        this.codeService = codeService;
        this.parameters = parameters;
        this.messageListener = messageListener;
    }
    Executor.prototype.withLibrary = function (lib) {
        this.library = lib;
        return this;
    };
    Executor.prototype.withParameters = function (params) {
        this.parameters = params != null ? params : {};
        return this;
    };
    Executor.prototype.withCodeService = function (cs) {
        this.codeService = cs;
        return this;
    };
    Executor.prototype.withMessageListener = function (ml) {
        this.messageListener = ml;
        return this;
    };
    Executor.prototype.exec_expression = function (expression, patientSource, executionDateTime) {
        return __awaiter(this, void 0, void 0, function () {
            var r, expr, p, patient_ctx;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        r = new results_1.Results();
                        expr = this.library.expressions[expression];
                        if (!(expr != null)) return [3 /*break*/, 5];
                        p = patientSource.currentPatient();
                        if (!(0, util_1.isPromise)(p)) return [3 /*break*/, 2];
                        return [4 /*yield*/, p];
                    case 1:
                        p = _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!p) return [3 /*break*/, 5];
                        patient_ctx = new context_1.PatientContext(this.library, p, this.codeService, this.parameters, executionDateTime, this.messageListener);
                        r.recordPatientResults(patient_ctx, (_a = {}, _a[expression] = expr.execute(patient_ctx), _a));
                        p = patientSource.nextPatient();
                        if (!(0, util_1.isPromise)(p)) return [3 /*break*/, 4];
                        return [4 /*yield*/, p];
                    case 3:
                        p = _b.sent();
                        _b.label = 4;
                    case 4: return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, r];
                }
            });
        });
    };
    Executor.prototype.exec = function (patientSource, executionDateTime) {
        return __awaiter(this, void 0, void 0, function () {
            var r, unfilteredContext, resultMap, _a, _b, _i, key, expr, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.exec_patient_context(patientSource, executionDateTime)];
                    case 1:
                        r = _e.sent();
                        unfilteredContext = new context_1.UnfilteredContext(this.library, r, this.codeService, this.parameters, executionDateTime, this.messageListener);
                        resultMap = {};
                        _a = [];
                        for (_b in this.library.expressions)
                            _a.push(_b);
                        _i = 0;
                        _e.label = 2;
                    case 2:
                        if (!(_i < _a.length)) return [3 /*break*/, 5];
                        key = _a[_i];
                        expr = this.library.expressions[key];
                        if (!(expr.context === 'Unfiltered')) return [3 /*break*/, 4];
                        _c = resultMap;
                        _d = key;
                        return [4 /*yield*/, expr.exec(unfilteredContext)];
                    case 3:
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        r.recordUnfilteredResults(resultMap);
                        return [2 /*return*/, r];
                }
            });
        });
    };
    Executor.prototype.exec_patient_context = function (patientSource, executionDateTime) {
        return __awaiter(this, void 0, void 0, function () {
            var r, p, patient_ctx, resultMap, _a, _b, _i, key, expr, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        r = new results_1.Results();
                        p = patientSource.currentPatient();
                        if (!(0, util_1.isPromise)(p)) return [3 /*break*/, 2];
                        return [4 /*yield*/, p];
                    case 1:
                        p = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (!p) return [3 /*break*/, 9];
                        patient_ctx = new context_1.PatientContext(this.library, p, this.codeService, this.parameters, executionDateTime, this.messageListener);
                        resultMap = {};
                        _a = [];
                        for (_b in this.library.expressions)
                            _a.push(_b);
                        _i = 0;
                        _e.label = 3;
                    case 3:
                        if (!(_i < _a.length)) return [3 /*break*/, 6];
                        key = _a[_i];
                        expr = this.library.expressions[key];
                        if (!(expr.context === 'Patient')) return [3 /*break*/, 5];
                        _c = resultMap;
                        _d = key;
                        return [4 /*yield*/, expr.execute(patient_ctx)];
                    case 4:
                        _c[_d] = _e.sent();
                        _e.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 3];
                    case 6:
                        r.recordPatientResults(patient_ctx, resultMap);
                        p = patientSource.nextPatient();
                        if (!(0, util_1.isPromise)(p)) return [3 /*break*/, 8];
                        return [4 /*yield*/, p];
                    case 7:
                        p = _e.sent();
                        _e.label = 8;
                    case 8: return [3 /*break*/, 2];
                    case 9: return [2 /*return*/, r];
                }
            });
        });
    };
    return Executor;
}());
exports.Executor = Executor;
//# sourceMappingURL=executor.js.map